// src/components/FancyLoader.jsx
import React from 'react';
import './FancyLoader.scss';

const FancyLoader = () => {
  return (
    <div className="fancy-loader-overlay">
      <div className="fancy-loader-popup">
        <div className="spinner" />
        <p>Carregando, por favor aguarde...</p>
      </div>
    </div>
  );
};

export default FancyLoader;
